import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  clearUploadId(event) {
    event.preventDefault()

    if(event.target.getAttribute('disabled')) { return }

    const url = new URL(window.location.href)
    url.searchParams.delete('upload_id')
    window.history.replaceState(history.state, '', url)

    Turbo.visit(event.currentTarget.href)
  }
}
